import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import Menu from '../../containers/menu/Sidecar';
import VersionHeader from './VersionHeader';
import PreviewContainer from '../../containers/preview/PreviewContainer';
import AlertLoader from '../../containers/alerts/AlertLoader';
import _actions from '../../actions';
import ErrorBoundary from '../ErrorBoundary';
import BannerLoader from '../../containers/alerts/BannerLoader';

class VersionBox extends Component {
    constructor(props) {
        super(props);
        this.togglePreviewState = this.togglePreviewState.bind(this);
        this.setAutoClose = this.setAutoClose.bind(this);
        this.state = { previewOn: this.props.versions.showPreview };
    }

    componentDidMount() {
        this.setAutoClose();
        window.addEventListener('resize', this.setAutoClose.bind(this));
        this.props.actions.getProject(this.props.match.params.projectId);
        this.props.actions.checkProjectConfig(this.props.match.params.projectId);
    }

    setAutoClose() {
        this.setState({ autoClose: window.innerWidth });
    }

    togglePreviewState() {
        this.setState({ previewOn: !this.props.versions.showPreview });
        this.props.actions.togglePreviewShown(this.props.versions.showPreview);
    }

    render() {
        const {
            name,
            versionNumber,
            saving,
            justSaved,
            previewCssClass,
        } = this.props;

        let previewClass = 'hidden';
        if (!this.state.previewOn) {
            previewClass = 'active s-hidden xs-hidden';
        }
        previewClass = `${previewCssClass} ${previewClass}`;
        return (
            <div
                ref="versionbox" // eslint-disable-line
                style={{
                    display: 'flex',
                    flex: '1',
                }}
            >
                <Menu
                    location={this.props.location}
                    match={this.props.match}
                    menuSection={this.props.menuSection}
                    menuItem={this.props.menuItem}
                    autoClose={this.state.autoClose}
                    previewOn={!this.props.previewOn && !this.state.previewOn}
                />
                <div className={`main ${this.props.sidecar.show ? 'open' : 'closed'}`}>
                    <div className="main-inner">

                        <div className="content-wrap">
                            <ErrorBoundary>
                                <VersionHeader
                                    name={name}
                                    versionNumber={versionNumber}
                                    saving={saving}
                                    justSaved={justSaved}
                                    togglePreview={this.togglePreviewState}
                                    previewOn={!this.props.previewOn}
                                    history={this.props.history}
                                />
                            </ErrorBoundary>
                            <div className={`content-inside-wrap ${this.props.alerts.data.filter((alert) => { return alert.type === 'banner'; }).length > 0 ? 'banner' : ''}`}>
                                <ErrorBoundary>
                                    <BannerLoader alerts={this.props.alerts} />
                                    <div className="content-under-banner">
                                        <AlertLoader />
                                        <div className="content-children">
                                            {this.props.children}
                                        </div>
                                    </div>
                                </ErrorBoundary>
                            </div>
                        </div>
                        {this.props.previewChild
                            && (
                                <PreviewContainer
                                    cssClass={this.props.showPreview ? previewClass : "hidden"}
                                    togglePreview={this.togglePreviewState}
                                    x={this.props.x}
                                    dark={this.props.dark}
                                    message={this.props.profiles?.data?.applicationType === 2 && (this.props.location.pathname.indexOf('general-info') > 0 || this.props.location.pathname.indexOf('results') > 0 || this.props.location.pathname.indexOf('logos') > 0) && 'This screen does not show in your branded app'}
                                >
                                    <ErrorBoundary>
                                        {this.props.previewChild}
                                    </ErrorBoundary>
                                </PreviewContainer>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VersionBox));
